export const vars = {
    BACKEND_URL: process.env.REACT_APP_API_URL,
}